var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9604 0.65625H2.03591C1.27308 0.65625 0.65625 1.25848 0.65625 2.00306V17.9933C0.65625 18.7379 1.27308 19.3438 2.03591 19.3438H17.9604C18.7233 19.3438 19.3438 18.7379 19.3438 17.9969V2.00306C19.3438 1.25848 18.7233 0.65625 17.9604 0.65625ZM6.20045 16.5808H3.42653V7.66041H6.20045V16.5808ZM4.81349 6.445C3.92291 6.445 3.20388 5.72596 3.20388 4.83904C3.20388 3.95211 3.92291 3.23308 4.81349 3.23308C5.70042 3.23308 6.41945 3.95211 6.41945 4.83904C6.41945 5.72231 5.70042 6.445 4.81349 6.445ZM16.5808 16.5808H13.8105V12.2447C13.8105 11.2118 13.7922 9.87955 12.3688 9.87955C10.9271 9.87955 10.7081 11.0074 10.7081 12.1717V16.5808H7.94146V7.66041H10.5986V8.87948H10.6351C11.0037 8.1787 11.9089 7.43777 13.2557 7.43777C16.0625 7.43777 16.5808 9.28462 16.5808 11.6863V16.5808V16.5808Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8d08a27d.svg";
export { ForwardRef as ReactComponent };